import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';

import { request, reportErrorToHoneybadger } from '../helpers/Requests'

import SetTitle from '../components/shared/SetTitle';
import HelpText from '../components/help/HelpText';

import { capitalize, adminUser, managerUser, setIdAndMethod, renderErrorWarning, renderErrors } from '../utilities/Forms.js'
import { debounce, getContrastYIQ } from '../utilities/Generic.js'
import Audits from '../components/shared/Audits';

class RoleForm extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleColorChange = this.handleColorChange.bind(this);
    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this);
    this.handlePartialChange = this.handlePartialChange.bind(this);
    this.debouncedHandlePersonSearch = debounce(this.handlePersonSearch.bind(this), 500);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    name: "",
    color_hex: "#EE2290",
    color: "#EE2290",
    text_color: "black",
    person_ids: [],
    partial: "",

    page: 1,
    people: [],

    nextColorLoaded: false,
    roleLoaded: false,
    peopleLoaded: false,
    unauthorized: "",
    errors: "",
    error: ""
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});
  }

  handleMultiCheckbox(event) {
    let name = parseInt(event.target.name);
    let value = event.target.checked;

    var person_ids = this.state.person_ids

    if (value === true) {
      if (!person_ids.includes(name)) {
        person_ids.push(name)
      }
    }
    else if (value === false) {
      if (person_ids.includes(name)) {
        let index = person_ids.indexOf(name)
        person_ids.splice(index, 1)
      }
    }

    this.setState({person_ids: person_ids});
  }

  handleColorChange(event) {
    let value = event.target.value;

    this.setState({color_hex: value});
    if (this.validateHexColor(value)) {
      this.setState({
        invalidColor: false,
        color: value,
        text_color: getContrastYIQ(value)
      })
    }
    else {
      this.setState({ invalidColor: true })
    }
  }

  validateHexColor(string) {
    if (string && string.length === 7 && string[0] === "#" && this.hexValidator(string)) {
      return true
    }
  }

  hexValidator(string) {
    const validCharacters = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"]
    for (let index in string) {
      if (index === "0") {
        continue
      }

      if (!validCharacters.includes(string[index].toUpperCase())) {
        return false
      }
    }
    return true
  }

  handlePartialChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({
      [name]: value,
      page: 1
    });

    this.debouncedHandlePersonSearch(value, 1)
  }

  handleNextPage(event) {
    let page = parseInt(this.state.page) + 1

    this.setState(prevState => ({
      page: page,
      people: [],
      peopleLoaded: false
    }))

    this.handlePersonSearch(this.state.partial, page)

    event.preventDefault();
  }

  handlePreviousPage(event) {
    let page = parseInt(this.state.page) - 1

    this.setState(prevState => ({
      page: page,
      people: [],
      peopleLoaded: false
    }))

    this.handlePersonSearch(this.state.partial, page)

    event.preventDefault();
  }

  handlePersonSearch(partial, page) {
    request('GET', `/v1/a/people/scoped_names_and_ids?person[type][]=staff&person[type][]=contractor&person[partial]=${partial}&page=${page}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ people: data, peopleLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, peopleLoaded: true })
      })
  }

  handleSubmit(event) {
    this.setState({ updating: true })

    var json = JSON.stringify({
      "role": {
        "name": this.state.name,
        "color": this.state.color,
        "person_ids": this.state.person_ids,
      }
    })

    const [id, method] = setIdAndMethod(this.props.mode, this.props.id)

    request(method, `/v1/a/roles/${id}`, json, () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", `Role ${this.props.mode}d successfully!`);

        if (this.props.mode === "create") {
          this.setState({ id: data.id, redirect: true })
        }
        else if (this.props.mode === "update") {
          this.props.closeEditPanel()
        }
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        if (error instanceof Error) {
          this.setState({ updating: false, error: error })
        }
        else {
          this.setState({ updating: false, errors: error })
        }
      })

    event.preventDefault();
  }

  renderPageButtons(page) {
    if (this.state.people.length < 250 && page === 1) {
      return ""
    }
    else {
      return (
        <div className="page-button-container">
          <button className="button new-button" onClick={this.handlePreviousPage} disabled={parseInt(page) < 2}>Previous Page</button>
          <button className="button new-button" onClick={this.handleNextPage} disabled={this.state.people.length <= 249}>Next Page</button>
        </div>
      )
    }
  }

  renderSaveButton() {
    if (adminUser() || managerUser()) {
      return <input type="submit" value="Save" disabled={this.state.updating} />
    }
    else {
      return <input type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  render() {
    const { name, color_hex, color, text_color, person_ids, partial, people, loaded, peopleLoaded, page, id, redirect, unauthorized, errors, error } = this.state;

    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (redirect && id) {
      return <Redirect to={`/configuration/roles/${id}`}/>
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    const title = this.props.mode === "create" ? "New" : "Edit"
    const formatName = name ? ` ${name} |` : ""

    return (
      <div>
        <SetTitle title={`${title} Role |${formatName} Roles`} />

        <form onSubmit={this.handleSubmit}>
          <div className="settings big-settings">
            <div className="row">
              <HelpText page={'roles'} section={'name'} />

              <label className="column">Role Name:</label>{ renderErrors(errors, 'name') }
              <input className="column" type="text" name="name" value={name} onChange={this.handleChange} />
            </div>

            <div className="row">
              <HelpText page={'roles'} section={'color'} />

              <label className="column">Role Colour:</label>{ renderErrors(errors, 'color') }
              <input className="column" type="text" name="color" value={color_hex} onChange={this.handleColorChange} />

              <label>Choose a default colour:</label>
              <div className="default-color-options">
                <div className="default-color-option fulfilment">
                  <input className="column" type="radio" name="color" id="#B80C09" value="#B80C09" checked={color === "#B80C09"} onChange={this.handleColorChange} />
                  <label htmlFor="#B80C09" style={{ backgroundColor: "#B80C09", color: "white" }}>Red</label>
                </div>

                <div className="default-color-option fulfilment">
                  <input className="column" type="radio" name="color" id="#FF8819" value="#FF8819" checked={color === "#FF8819"} onChange={this.handleColorChange} />
                  <label htmlFor="#FF8819" style={{ backgroundColor: "#FF8819", color: "black" }}>Orange</label>
                </div>

                <div className="default-color-option fulfilment">
                  <input className="column" type="radio" name="color" id="#EEE622" value="#EEE622" checked={color === "#EEE622"} onChange={this.handleColorChange} />
                  <label htmlFor="#EEE622" style={{ backgroundColor: "#EEE622", color: "black" }}>Yellow</label>
                </div>

                <div className="default-color-option fulfilment">
                  <input className="column" type="radio" name="color" id="#22EE80" value="#22EE80" checked={color === "#22EE80"} onChange={this.handleColorChange} />
                  <label htmlFor="#22EE80" style={{ backgroundColor: "#22EE80", color: "black" }}>Green</label>
                </div>

                <div className="default-color-option fulfilment">
                  <input className="column" type="radio" name="color" id="#222AEE" value="#222AEE" checked={color === "#222AEE"} onChange={this.handleColorChange} />
                  <label htmlFor="#222AEE" style={{ backgroundColor: "#222AEE", color: "white" }}>Blue</label>
                </div>

                <div className="default-color-option fulfilment">
                  <input className="column" type="radio" name="color" id="#8826BF" value="#8826BF" checked={color === "#8826BF"} onChange={this.handleColorChange} />
                  <label htmlFor="#8826BF" style={{ backgroundColor: "#8826BF", color: "white" }}>Violet</label>
                </div>

                <div className="default-color-option fulfilment">
                  <input className="column" type="radio" name="color" id="#EE2290" value="#EE2290" checked={color === "#EE2290"} onChange={this.handleColorChange} />
                  <label htmlFor="#EE2290" style={{ backgroundColor: "#EE2290", color: "white" }}>Magenta</label>
                </div>
              </div>
              <div className="fulfilment preview">
                <label>Role colour preview:</label>
                <div className="role-title"><div className="role-preview-color" style={{ backgroundColor: color, color: text_color }}>{name}</div></div>
              </div>
            </div>
          </div>

          <div className="settings big-settings">
            <div className="row">
              <HelpText page={'roles'} section={'people'} />

              <label className="column">Assign Staff:</label>{ renderErrors(errors, 'person') }

              <div className="scroll-box">
                <div className="search-box">
                  <input name="partial" placeholder="Enter text to search" className="search-text" onChange={this.handlePartialChange} value={partial} />

                  <div className="scrollable-table">
                    <table className="checkbox-table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Type</th>
                          <th>Existing Role</th>
                          <th>Assigned</th>
                        </tr>
                      </thead>
                      <tbody>
                        {people.map((person) => (
                          <tr key={person.id}>
                            <td>
                              <Link to={`/people/${person.id}`}>{person.full_name}</Link>
                            </td>
                            <td>
                              {capitalize(person.type_of_person)}
                            </td>
                            <td>
                              {person.roles.map((role) => (
                                <Link key={role.id} to={`/configuration/roles/${role.id}`}>{role.name}<br></br></Link>
                              ))}
                            </td>
                            <td className="center-cell">
                              <input className="column" type="checkbox" data-name={person.name} name={person.id} checked={person_ids.includes(person.id)} onChange={this.handleMultiCheckbox} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                    {peopleLoaded === false ? (
                        <div className="long-tr white-bg">
                          <div className="long-td">
                            Loading...
                          </div>
                        </div>
                      ) : (null)}
                  </div>

                  {this.renderPageButtons(page)}
                </div>
              </div>
            </div>
          </div>

          <div className="settings big-settings">
            { this.renderSaveButton() }
            { renderErrorWarning(errors) }
          </div>
        </form>

        { this.props.mode === "update" && <Audits klass="Role" id={this.props.id} /> }
      </div>
    );
  }

  componentDidMount() {
    let id = this.props.id;

    if (this.props.mode === "create") {
      request('GET', '/v1/a/roles/next_default_color', null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          this.setState({
            color: data.color,
            color_hex: data.color,
            text_color: getContrastYIQ(data.color),
            loaded: true
          })
        })
        .catch(error => {
          reportErrorToHoneybadger(error)

          this.setState({ error, loaded: true })
        })
    }
    else {
      request('GET', `/v1/a/roles/${id}`, null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          this.setState({
            name: data.name,
            color: data.color,
            color_hex: data.color,
            text_color: getContrastYIQ(data.color),
            person_ids: data.person_ids,
            loaded: true
          })
        })
        .catch(error => {
          reportErrorToHoneybadger(error)

          this.setState({ error, loaded: true })
        })
    }

    request('GET', `/v1/a/people/scoped_names_and_ids?person[type][]=staff&person[type][]=contractor&page=${this.state.page}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ people: data, peopleLoaded: true })
      })
      .catch(error => {
        reportErrorToHoneybadger(error)

        this.setState({ error, peopleLoaded: true })
      })
  }
}

export default RoleForm;
